import HotelRatesTablesCellsTdOtb from 'lumen/components/hotel/rates/tables/cells/td-otb';

export default class HotelRatesTablesCellsTdMarketOtb extends HotelRatesTablesCellsTdOtb {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedOccupancyValue() {
    return this.occupancy?.formattedBenchmarkPercentage;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isMissing() {
    if (!this.occupancy) {
      return true;
    }
    return this.occupancy?.isBenchmarkMissing;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get occupancyChangeValue() {
    if (this.showOccupancyChanges) {
      return this.occupancy?.benchmarkChangeVersusPercentage(
        this.occupancyChange,
      );
    }
    return null;
  }
}
